import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MobileFilters from '../Filter/MobileFilters';
import { updateFilters, updateBaseFilters, setSelectedTab } from '../../../reducers/filtersSlice';

import FadeIn from '../../../components/FadeIn';

const MobileDropdown = () => {
  const { totalPrevision } = useSelector((state) => state.properties);
  const { baseCollection } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(updateBaseFilters())
    dispatch(setSelectedTab(null))
    pushDataLayer();
  }

  const pushDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'search_properties',
      ...baseCollection
    })
  }

  const handleCancel = () => {
    dispatch(updateFilters(baseCollection))
    dispatch(setSelectedTab(null))
  }

  return(
    <FadeIn>
      <div className='vesta-filters-modal vesta-flex-col-center vesta-gap-20 vesta-page-xs-padding'>
        <div className='vesta-flex-col-start vesta-gap-15'>
          <MobileFilters />
        </div>

        <div className='vesta-flex-col-center vesta-gap-15 vesta-padding-responsive'>
          <div className='vesta-button--primary typo-button vesta-flex-row-center vesta-gap-10' onClick={handleSubmit}>
            {totalPrevision > 0 && (`Voir ${totalPrevision > 1 ? `les ${totalPrevision} biens` : 'le bien'}`)}
            {totalPrevision <= 0 && ('Aucun bien')}
          </div>

          <div className='vesta-button--tertiary typo-button vesta-flex-row-center' onClick={() => handleCancel()}>Réinitialiser les filtres</div>
        </div>
      </div>
    </FadeIn>
  )
};

export default MobileDropdown;
